import { FC } from "react"
import { ApplicationFormList } from "../../../module/applicationForm/containers/list"

export const ApplicationFormSummerTime: FC = () => <ApplicationFormList />
